import styles from './Eula.scss';
import { Component } from 'react';


export class Eula extends Component {
    render(){
        const eulaText = this.props.eula || '';
        const eula = { __html: eulaText };
        return (
            <div className={styles.container} data-cy="Eula">
                <div className={styles.eula}
                    dangerouslySetInnerHTML={eula} >
                </div>
            </div>
        );
    }
}
